import { useTranslation } from "@redotech/redo-i18n";
import { MerchantAppReturn } from "@redotech/redo-return-core-common/return";
import { Flex } from "@redotech/redo-web/flex";
import { ImageDisplayWithPlaceholder } from "@redotech/redo-web/image-display-with-placeholder";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

type ReturnProduct = MerchantAppReturn["products"][number];

export const GroupProductsList = memo(function GroupProductsList({
  products,
  formatCurrency,
}: {
  products: ReturnProduct[];
  formatCurrency: (value: number) => string;
}) {
  const { t } = useTranslation();
  if (products.length === 0) {
    return null;
  }

  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Items ({{count}})", { count: products.length })}
      </Text>
      {products.map((product) => (
        <Flex align="center" gap="lg" key={product._id}>
          <ImageDisplayWithPlaceholder
            alt={product.product_title}
            size="sm"
            src={product.images?.[0] ?? ""}
          />
          <Flex dir="column" flex={1} gap="xxs" minW="none" overflow="hidden">
            <Text fontSize="xs" fontWeight="medium" textColor="primary">
              {product.product_title}
            </Text>
            {product.variant_title && (
              <Text fontSize="xxs" fontWeight="regular" textColor="secondary">
                {product.variant_title}
              </Text>
            )}
            <Text fontSize="xs" fontWeight="medium" textColor="primary">
              {formatCurrency(Number(product.price))}
            </Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
});
